import { type } from "arktype";
import {
  NewPasswordSchemaOptional,
  passwordConfirmationNarrow,
} from "./new-password-schema";

export const SignUpFormSchema = type({
  email: "string.email",
})
  .and(NewPasswordSchemaOptional)
  .narrow(passwordConfirmationNarrow({ skipWhenNoPassword: true }));

export type SignUpFormValues = typeof SignUpFormSchema.infer;

export const defaultSignUpFormValues: SignUpFormValues = {
  email: "",
  password: "",
  confirmPassword: "",
};
